import { render, staticRenderFns } from "./RulesDialog.vue?vue&type=template&id=16c249c0&scoped=true"
import script from "./RulesDialog.vue?vue&type=script&lang=js"
export * from "./RulesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c249c0",
  null
  
)

export default component.exports